import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePrograms(memberId) {
  const [programs, setPrograms] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.members.programs, { params: { student_id: memberId } })
      .then((response) => {
        setPrograms(response.data.data);
      });
  }, []);

  return programs;
}
